import { createAdapterToBankAccount } from "../../../../parametry/financial/bankAccount/adapters/bankAccount.adapter";
import { createAdapterToBankTransactionClassification } from "../../../../parametry/financial/bankTransactionClassification/adapters/bankTransactionClassification.adapter";
import { createAdapterToBankTransactionType } from "../../../../parametry/financial/bankTransactionType/adapters/bankTransactionType.adapter";
import { createAdapterToConcept } from "../../../../parametry/financial/concept/adapters/concept.adapter";
import { numericalDateToString, stringToNumericalDate } from "../../../../utilities/dateUtils";
import { StatementMovement, StatementMovementEndpoint, StatementMovementError, StatementMovementErrorEndpoint } from "../domain/StatementMovement.model";
import { StatementMovementImportEndpoint, StatementMovementImportErrorEndpoint } from "../domain/StatementMovementImport.model";

type Dictionary = {
    [key: string]: string;
};

const statementMovementAttributesDiccionary: Dictionary = {
    id: 'ExtractoBancarioMovimientoID',
    dateId: 'FechaID',
    bankId: 'BancoID',
    bankAccountId: 'CuentaBancariaID',
    conceptId: 'ConceptoID',
    currencyId: 'MonedaID',
    bankTransactionClassificationId: 'ClasificacionMovimientoBancarioID',
    amount: 'Importe',
    hourId: 'HoraID',
    bankTransactionTypeId: 'TipoMovimientoBancarioID',
    valueDate: 'FechaValor',
    processDate: 'FechaProceso',
    CUIT:'CUIT',
}

export const createAdapterToFieldStatementMovementEndpoint = (key: string): string => {
    return statementMovementAttributesDiccionary[key];
}

export const createAdapterToStatementMovementEndpoint = (statementMovement: StatementMovement) => {    
    const formattedStatementMovement: Partial<StatementMovementEndpoint> = {
        ExtractoBancarioMovimientoID: statementMovement.id ?? undefined,
        FechaID: stringToNumericalDate(statementMovement.valueDate),
        CuentaBancariaID: statementMovement.bankAccountId,
        ConceptoID: statementMovement.conceptId ,
        ClasificacionMovimientoBancarioID: statementMovement.bankTransactionClassificationId,
        Importe: statementMovement.amount,
        HoraID: parseInt(statementMovement?.hourId?.replace(/:/g, '')),
        TipoMovimientoBancarioID: statementMovement.bankTransactionTypeId,
        FechaValor: statementMovement.valueDate ? stringToNumericalDate(statementMovement.valueDate) : undefined,
        FechaProceso: statementMovement.processDate ? stringToNumericalDate(statementMovement.processDate) : undefined,
        CUIT: statementMovement.CUIT,
    };
    return formattedStatementMovement;
}

export const createAdapterToStatementMovement = (statementMovementEndpoint: StatementMovementEndpoint) => {
    const formattedHour = statementMovementEndpoint?.HoraID?.toString()
    const formattedStatementMovement: StatementMovement = {
        id: statementMovementEndpoint.ExtractoBancarioMovimientoID ?? undefined,
        dateId: numericalDateToString(statementMovementEndpoint.FechaID),
        bankAccountId: statementMovementEndpoint.CuentaBancariaID,
        bankAccount: statementMovementEndpoint.CuentaBancaria? createAdapterToBankAccount(statementMovementEndpoint.CuentaBancaria) : undefined,
        conceptId: statementMovementEndpoint.ConceptoID ,
        concept: statementMovementEndpoint.Concepto? createAdapterToConcept(statementMovementEndpoint.Concepto) : undefined,
        bankTransactionClassificationId: statementMovementEndpoint.ClasificacionMovimientoBancarioID,
        bankTransactionClassification: statementMovementEndpoint.ClasificacionMovimientoBancario? createAdapterToBankTransactionClassification(statementMovementEndpoint.ClasificacionMovimientoBancario) : undefined,
        amount: statementMovementEndpoint.Importe,
        hourId: formattedHour,
        bankTransactionTypeId: statementMovementEndpoint.TipoMovimientoBancarioID,
        bankTransactionType: statementMovementEndpoint.TipoMovimientoBancario? createAdapterToBankTransactionType(statementMovementEndpoint.TipoMovimientoBancario) : undefined,
        valueDate: numericalDateToString(statementMovementEndpoint.FechaValor),
        processDate: numericalDateToString(statementMovementEndpoint.FechaProceso),
        CUIT: statementMovementEndpoint.CUIT,
    };
    return formattedStatementMovement;
}

export const createAdapterToStatementMovementErrorEndpoint = (statementMovement: StatementMovementError) => {    
    const formattedStatementMovement: StatementMovementImportErrorEndpoint = {
        FechaMovimiento: stringToNumericalDate(statementMovement.valueDate),
        NumeroCuentaLargo: statementMovement.longAccountNumber,
        CodigoBanco: statementMovement.bankCode,
        CodigoOperacion: statementMovement.opCode ? statementMovement.opCode : "",
        CodigoOperacionBanco: statementMovement.bankOpCode,
        Importe: statementMovement.amount,
        TipoMovimiento: statementMovement.movementType,
        TipoMoneda: statementMovement.currencyId ? statementMovement.currencyId?.toString() : "0",
        CodigoDepositante: statementMovement.depositorCode,
        SucursalOrigen: statementMovement.branch,
        NumeroComprobante: statementMovement.voucherNumber ? statementMovement.voucherNumber : "",
        InformacionLibre: statementMovement.freeInfo ? statementMovement.freeInfo : "",
        FechaValor: stringToNumericalDate(statementMovement.valueDate),
        FechaProceso: stringToNumericalDate(statementMovement.processDate),
        CUIT: statementMovement.CUIT,
        TipoRegistro: statementMovement.registerType,
        NumeroCuentaCorto: statementMovement.bankAccountNumberShort,
        CBU: statementMovement.CBU,
        Denominacion: statementMovement.denomination,
        MovimientoID: statementMovement.id,
        ClasificacionMovimientoBancarioID: statementMovement.bankTransactionClassificationId,
        ConceptoID: statementMovement.conceptId,
        LogError: statementMovement.logError,
        CuentaBancariaID: statementMovement.bankAccountId
    };
    return formattedStatementMovement;
}

export const createAdapterToStatementMovementError = (statementMovementEndpoint: StatementMovementErrorEndpoint) => {
    const formattedStatementMovement: StatementMovementError = {
        id: statementMovementEndpoint.MovimientoID ?? undefined,
        dateId: numericalDateToString(statementMovementEndpoint.FechaMovimiento),
        codeBCRA: statementMovementEndpoint.CodigoBCRA ?? undefined,
        opCode: statementMovementEndpoint.CodigoOperacion ?? undefined,
        bankOpCode: statementMovementEndpoint.CodigoOperacionBanco ?? undefined,
        bankName: statementMovementEndpoint.BancoCorto ?? undefined,
        bankAccountId: statementMovementEndpoint.CuentaBancariaID ?? undefined,
        longAccountNumber: statementMovementEndpoint.NumeroCuentaLargo ?? undefined,
        depositorCode: statementMovementEndpoint.CodigoDepositante,
        branch: statementMovementEndpoint.SucursalOrigen,
        conceptId: statementMovementEndpoint.ConceptoID,
        conceptName: statementMovementEndpoint.Concepto,
        bankTransactionClassificationId: statementMovementEndpoint.ClasificacionMovimientoBancarioID,
        bankTransactionClassification: statementMovementEndpoint.ClasificacionMovimientoBancario,
        duplicatedClassifications: statementMovementEndpoint.Clasificaciones?.split(", ") || undefined,
        amount: statementMovementEndpoint.Importe,
        bankTransactionTypeId: statementMovementEndpoint.TipoMovimientoID,
        movementType: statementMovementEndpoint.TipoMovimiento,
        currencyId: parseInt(statementMovementEndpoint.TipoMoneda) ?? undefined,
        currency: statementMovementEndpoint.Moneda ?? undefined,
        voucherNumber: statementMovementEndpoint.NumeroComprobante,
        freeInfo: statementMovementEndpoint.InformacionLibre,
        valueDate: numericalDateToString(statementMovementEndpoint.FechaValor),
        processDate: numericalDateToString(statementMovementEndpoint.FechaProceso),
        movementDate: numericalDateToString(statementMovementEndpoint.FechaMovimiento),
        CUIT: statementMovementEndpoint.CUIT,
        currencyType: statementMovementEndpoint.TipoMoneda,
        logError: statementMovementEndpoint.LogError,
        registerType: statementMovementEndpoint.TipoRegistro,
        bankCode: statementMovementEndpoint.CodigoBanco,
        bankAccountNumberShort: statementMovementEndpoint.NumeroCuentaCorto,
        CBU: statementMovementEndpoint.CBU,
        denomination: statementMovementEndpoint.Denominacion,
        p1Code: statementMovementEndpoint.CodigoP1
    };
    return formattedStatementMovement;
}